<template>
  <div class="item-cell">
    <div class="title">{{ item.label }}</div>
    <div class="set">
      <el-checkbox-group v-model="checkList">
        <el-checkbox
        v-for="item in dicData"
        :key="item.id"
        :label="item.value">{{item.label}}</el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="operate">
      <el-button @click="handleDel(item)" type="text" icon="el-icon-delete" />
    </div>
  </div>
</template>

<script>
import { mixinBranch } from '../../mixins'
export default {
  mixins: [mixinBranch],
  mounted() {
    const {
      conditionValue
    } = this.item
    if (conditionValue?.length) {
      const checkList = []
      conditionValue.map(item => {
        checkList.push(item.value)
      })
      this.checkList = checkList
    }
  }
}
</script>

<style scoped>
@import './item.scss';
</style>
